export type ActId = 1 | 2 | 3 | 4 | 5;

export type ActConfig = {
  id: ActId;
  name: string;
  /** Start of act as fraction of run music/progress 0..1 */
  from: number;
  to: number;
  intensity: number;
  /** Multiplier on enemy bullet spawn rate */
  density: number;
};

/** ~3.5 min ritual — denser, snappier acts */
export const DEFAULT_ACTS: ActConfig[] = [
  { id: 1, name: "Alone", from: 0, to: 0.16, intensity: 0.4, density: 1.15 },
  { id: 2, name: "Weight", from: 0.16, to: 0.38, intensity: 0.65, density: 1.45 },
  { id: 3, name: "Offer", from: 0.38, to: 0.58, intensity: 0.8, density: 1.7 },
  { id: 4, name: "Together", from: 0.58, to: 0.82, intensity: 0.95, density: 1.95 },
  { id: 5, name: "Clear", from: 0.82, to: 1, intensity: 1.1, density: 2.15 },
];

export class ActDirector {
  acts: ActConfig[];
  progress = 0;
  current: ActConfig;

  constructor(acts: ActConfig[] = DEFAULT_ACTS) {
    this.acts = acts;
    this.current = acts[0]!;
  }

  /** progress 0..1 from music or elapsed/duration */
  setProgress(p: number): ActConfig {
    this.progress = Math.min(1, Math.max(0, p));
    const found =
      this.acts.find((a) => this.progress >= a.from && this.progress < a.to) ??
      this.acts[this.acts.length - 1]!;
    this.current = found;
    return found;
  }

  get intensity(): number {
    return this.current.intensity;
  }

  get density(): number {
    return this.current.density;
  }

  get finished(): boolean {
    return this.progress >= 1;
  }
}
